import * as React from 'react';
import { Trans } from 'react-i18next';
import { ButtonBase } from '@mui/material'

export type Props = {
	onClick?: Function
	layerListOpened?: boolean
}

export default class LayersButton extends React.Component<Props> {
	render() {
		let icon = this.props.layerListOpened ? 'layers-blue' : 'layers-clear';
		return	<ButtonBase style={ {borderRadius: '3px', marginTop: '15px'} } >
			<div onClick={() => this.props.onClick()} className="action-buttons-icon layers-btn grey-bg">
				<img src={"static/img/icons/" + icon + "-icon.svg"} alt="" width="25" height="25" />
				<div className="text">LAYERS</div>
			</div>
		</ButtonBase>
	}
}